import React from 'react';
import Link from 'gatsby-link';

import Helmet from '../components/Helmet';
import Footer from '../components/Footer';
import Title from '../components/Title';
import { rhythm } from '../utils/typography';

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark;
    const siteTitle = this.props.data.site.siteMetadata.title;
    const { previous, next, slug } = this.props.pathContext;

    return (
      <div>
        <Helmet title={`${post.frontmatter.title} | ${siteTitle}`}>
          <link rel="canonical" href={`https://desiatov.com${slug}`} />
          {post.frontmatter.isDraft && <meta name="robots" content="noindex" />}
          {post.frontmatter.description && (
            <meta name="description" content={post.frontmatter.description} />
          )}
          <meta property="og:description" content={post.frontmatter.description} />
          <meta property="og:url" content={`https://desiatov.com${slug}`} />
          {post.frontmatter.topImg && (
            <meta
              property="og:image"
              content={`https://desiatov.com${post.frontmatter.topImg.publicURL}`}
            />
          )}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:description" content={post.frontmatter.description} />
          <meta name="twitter:title" content={`${post.frontmatter.title} | ${siteTitle}`} />
        </Helmet>
        <a name="title" style={{ color: 'black' }}>
          <Title>{post.frontmatter.title}</Title>
        </a>
        <small
          style={{
            display: 'block',
            marginBottom: rhythm(1),
          }}
        >
          {post.frontmatter.date}
        </small>
        <div dangerouslySetInnerHTML={{ __html: post.html }} />
        {!post.frontmatter.isDraft ? (
          <div>
            <hr
              style={{
                marginBottom: rhythm(1),
              }}
            />
            <p>
              If you enjoyed this article, please consider <a href="/sponsor">becoming a sponsor</a>
              . My goal is to produce content like this and to work on open-source projects full
              time, every single contribution brings me closer to it! This also benefits you as a
              reader and as a user of{' '}
              <a href="https://github.com/MaxDesiatov">my open-source projects</a>, ensuring that my
              blog and projects are constantly maintained and improved.
            </p>
          </div>
        ) : (
          ''
        )}
        <hr
          style={{
            marginBottom: rhythm(1),
          }}
        />
        <ul
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            listStyle: 'none',
            padding: 0,
          }}
        >
          {previous && (
            <li>
              <Link to={previous.fields.slug} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            </li>
          )}

          {next && (
            <li>
              <Link to={next.fields.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            </li>
          )}
        </ul>
        <Footer />
      </div>
    );
  }
}

export default BlogPostTemplate;

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      excerpt(pruneLength: 200)
      frontmatter {
        isDraft
        description
        title
        date(formatString: "DD MMMM, YYYY")
        topImg {
          publicURL
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/BlogPost.js